module.exports = __webpack_public_path__ + "img/crown1.1e86f33d.png";